"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import MarqueeRow from "./MarqueeRow";

const CERTIFICATIONS = [
  { key: "asq", src: "/reconocimientos/ASQ.svg", alt: "ASQ — Airport Service Quality" },
  { key: "skytrax", src: "/reconocimientos/Skytrax.svg", alt: "Skytrax" },
  { key: "oag", src: "/reconocimientos/OAG.svg", alt: "OAG" },
  { key: "cirium", src: "/reconocimientos/Cirium.svg", alt: "Cirium" },
  { key: "iso", src: "/reconocimientos/iso 14001-2015.svg", alt: "ISO 14001:2015" },
  { key: "moodys", src: "/reconocimientos/moodys ratings.svg", alt: "Moody's Ratings" },
  { key: "brc", src: "/reconocimientos/BRC Ratings.svg", alt: "BRC Ratings" },
] as const;

/** Banda de certificaciones y reconocimientos: cierra la página. */
export default function AwardsMarquee() {
  const t = useTranslations("homeStats");

  return (
    <section
      aria-label={t("awards")}
      className="w-full bg-[var(--fondoGeneral-secciones)] border-t-2 border-[var(--botonesSecundarios-iconoLlamativo)] py-10 md:py-14 overflow-hidden"
    >
      <MarqueeRow direction="right" speed={95}>
        {CERTIFICATIONS.map((cert) => (
          <div
            key={cert.src}
            className="flex items-center gap-4 px-6 md:px-10 border-l border-white/10"
          >
            <div className="relative shrink-0 w-24 md:w-28 h-12 md:h-14">
              <Image
                src={cert.src}
                alt={cert.alt}
                fill
                unoptimized
                className="object-contain opacity-70 [filter:brightness(0)_invert(1)]"
              />
            </div>
            {/* Resumen del premio: el logo solo no dice qué se reconoció */}
            <span className="text-[13px] md:text-sm text-[var(--blanco)]/70 leading-snug max-w-[13rem] md:max-w-[16rem]">
              {t(`awardItems.${cert.key}`)}
            </span>
          </div>
        ))}
      </MarqueeRow>
    </section>
  );
}
